/**
 * Game logic state for Player.
 * Pure data — no Phaser dependencies.
 * Used by tests and rendering layer.
 */
export interface IPlayerLogicState {
  x: number;
  y: number;
  vx: number;
  vy: number;
  facing: 'left' | 'right';
  hp: number;
  maxHp: number;
  onGround: boolean;
  canDoubleJump: boolean;
  hasDoubleJumped: boolean;
  isInvulnerable: boolean;
  invulnerabilityTimer: number;
  isHurt: boolean;
  hurtTimer: number;
  speedBoostDuration: number;
  stoneCooldown: number;
  activeStones: number;
  /** Stone ammo: total stones available to throw. */
  stones: number;
  coins: { cup: number; usd: number; eur: number };
  lastSafeX: number;
  lastSafeY: number;
  checkpointX: number;
  checkpointY: number;
}

export function createPlayerLogicState(x: number, y: number): IPlayerLogicState {
  return {
    x, y,
    vx: 0, vy: 0,
    facing: 'right',
    hp: 100,
    maxHp: 100,
    onGround: false,
    canDoubleJump: true,
    hasDoubleJumped: false,
    isInvulnerable: false,
    invulnerabilityTimer: 0,
    isHurt: false,
    hurtTimer: 0,
    speedBoostDuration: 0,
    stoneCooldown: 0,
    activeStones: 0,
    stones: 0,
    coins: { cup: 0, usd: 0, eur: 0 },
    lastSafeX: x,
    lastSafeY: y,
    checkpointX: x,
    checkpointY: y,
  };
}

export function copyPlayerLogicState(state: IPlayerLogicState): IPlayerLogicState {
  return {
    ...state,
    coins: { ...state.coins },
  };
}
